<ngx-skeleton-loader
  [appearance]="appearance"
  [count]="count"
  [theme]="theme"
></ngx-skeleton-loader>
